export function langFromPath(path) {
  return path === "/en" || path.startsWith("/en/") ? "en" : "fr"
}
// Path on the other language, same page (both trees mirror each other).
export function switchPath(path, to) {
  const rest = path.replace(/^\/(fr|en)(?=\/|$)/, "")
  return `/${to}${rest}`
}
const NAV_EN = [
  {
    label: "About us",
    items: [
      {
        label: "Who are we?",
        to: "/en/about",
        desc: "Our organisation and accreditations",
      },
      { label: "Company structure", to: "/en/about/structure" },
      { label: "Vision, mission and core values", to: "/en/about/vision" },
      {
        label: "International approval",
        to: "/en/about/international-approval",
      },
      { label: "Locations", to: "/en/about#implantations" },
    ],
  },
  {
    label: "Certification",
    items: [
      {
        label: "Our certification",
        to: "/en/certification/procedure",
      },
      { label: "Product categories", to: "/en/certification/categories" },
      {
        label: "Our services",
        to: "/en/certification/services",
        desc: "Diagnostics, auditing and training",
      },
    ],
  },
  {
    label: "Policies",
    items: [
      { label: "Halal guarantee", to: "/en/policies/guarantee" },
      { label: "Integrity policy", to: "/en/policies/integrity" },
      { label: "Fee regulation", to: "/en/policies/fee-regulation" },
      {
        label: "Confidentiality, impartiality and applicant rights",
        to: "/en/policies/confidentiality-and-impartiality",
      },
    ],
  },
  {
    label: "Contact",
    items: [
      { label: "Apply for certification", to: "/en/contact/apply" },
      { label: "Information request", to: "/en/contact/information" },
      { label: "Feedback and complaints", to: "/en/contact/feedback" },
      { label: "Check a halal certificate", to: "/en/contact/check" },
      {
        label: "Saudi Arabia export approval",
        to: "/en/contact/saudi-application",
      },
    ],
  },
]
export const T = {
  fr: {
    home: "Accueil",
    news: "Actualités",
    apply: "Être certifié",
    check: "Vérifier un certificat",
    menuOpen: "Ouvrir le menu",
    menuClose: "Fermer le menu",
    mainNav: "Navigation principale",
    mobileNav: "Navigation mobile",
    skip: "Aller au contenu",
    crumbs: "Fil d’Ariane",
    footerMember:
      "Membre du groupe Halal Correct Certification. Inspection et certification halal.",
    findUs: "Nous trouver",
    useful: "Liens utiles",
    contactUs: "Nous contacter",
    useLinks: [
      ["Qui sommes-nous ?", "/fr/about"],
      ["Structure de l’entreprise", "/fr/about/structure"],
      ["Nos services", "/fr/certification/services"],
      ["Actualités", "/fr/blog"],
    ],
    contactLinks: [
      ["Faire une demande", "/fr/contact/apply"],
      ["Demande d’informations", "/fr/contact/information"],
      ["Avis et réclamations", "/fr/contact/feedback"],
      ["Vérifier un certificat halal", "/fr/contact/check"],
    ],
    copyright: "© Copyright Halal Correct France. Tous droits réservés.",
    ctaTitle: "Êtes-vous producteur ou fournisseur de produits halal ?",
    ctaText: "Découvrez nos certifications halal internationales.",
    call: "Appeler",
    form: {
      required: "Les champs marqués d’un * sont obligatoires.",
      name: "Nom et prénom *",
      email: "E-mail *",
      errName: "Indiquez votre nom.",
      errEmail:
        "Saisissez une adresse e-mail valide, par ex. nom@entreprise.fr.",
      errMsg: "Rédigez votre message.",
      submit: "Préparer mon message",
      hint: "Votre messagerie s’ouvrira avec le message pré-rempli.",
      opened: "Votre messagerie devrait s’être ouverte. Sinon, écrivez-nous à",
      nameL: "Nom",
      emailL: "E-mail",
    },
    nav: null,
  },
  en: {
    home: "Home",
    news: "Blog",
    apply: "Apply now",
    check: "Check a certificate",
    menuOpen: "Open menu",
    menuClose: "Close menu",
    mainNav: "Main navigation",
    mobileNav: "Mobile navigation",
    skip: "Skip to content",
    crumbs: "Breadcrumb",
    footerMember:
      "Member of the Halal Correct Certification Group. Halal inspection and certification.",
    findUs: "Find us",
    useful: "Useful links",
    contactUs: "Contact us",
    useLinks: [
      ["Who are we?", "/en/about"],
      ["Company structure", "/en/about/structure"],
      ["Our services", "/en/certification/services"],
      ["Blog", "/en/blog"],
    ],
    contactLinks: [
      ["Apply now", "/en/contact/apply"],
      ["Information request", "/en/contact/information"],
      ["Feedback and complaints", "/en/contact/feedback"],
      ["Check a halal certificate", "/en/contact/check"],
    ],
    copyright: "© Copyright Halal Correct France. All rights reserved.",
    ctaTitle: "Are you a Halal producer or Halal supplier?",
    ctaText: "If you are interested in international Halal certifications.",
    call: "Call",
    form: {
      required: "Fields marked * are required.",
      name: "Full name *",
      email: "Email *",
      errName: "Enter your name.",
      errEmail: "Enter a valid email address, e.g. name@company.com.",
      errMsg: "Write your message.",
      submit: "Prepare my message",
      hint: "Your email app will open with the message filled in.",
      opened: "Your email app should have opened. If not, write to us at",
      nameL: "Name",
      emailL: "Email",
    },
    nav: NAV_EN,
  },
}
